import { Injectable } from '@angular/core';
import { LoginResponseDto } from '@flamingo/service/flamingo-auth.service';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import { LoginDto } from './dto/login.dto';

@Injectable()
export class AuthService {
  constructor(private http: FlamingoHttpService) {}

  login(dto: LoginDto): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>('/auth/login', dto);
  }

  resetEmail(username: string): Observable<void> {
    return this.http.post<void>('/auth/reset-code', { username });
  }

  checkCode(codeDto: { username: string; code: string }): Observable<void> {
    return this.http.post<void>('/auth/check-code', codeDto);
  }

  activate(activateDto: { username: string; code: string; password: string }): Observable<void> {
    return this.http.post<void>('/auth/activate', activateDto);
  }
}
